import React, { Fragment } from "react";
import Card from "react-bootstrap/esm/Card";
import Image from "react-bootstrap/esm/Image";
import Slider from "react-slick";
import { Icon } from "../../components/icon";
import { Testimonial } from "../../data/partners";
import { useMediaQuery } from "../../hooks/use_media_query";
import { useI18n } from "../../lib/i18n/i18n_provider";

import "./offering_testimonials.css";

interface OfferingTestimonialsProps {
  title?: string;
  testimonials: Testimonial[];
}

export function OfferingTestimonials(props: OfferingTestimonialsProps) {
  const { title, testimonials } = props;

  const { locale, fbt } = useI18n();
  const { device } = useMediaQuery();
  const slidesCount = Math.min(
    testimonials.length,
    ["mobile", "tablet", "desktop"].indexOf(device) + 1
  );

  return (
    <div data-testid="testimonials" className="testimonials">
      <h3 className="testimonials__title">
        {title || fbt("Our Customers Say")}
      </h3>

      <div className="row gx-0 gx-sm-4">
        <Slider
          slidesToShow={slidesCount}
          arrows={device !== "mobile"}
          dots
          centerPadding="10"
          rtl={locale.direction === "rtl"}
        >
          {testimonials.map((testimonial, index) => {
            return (
              <Card
                className="rounded-4 h-100"
                key={index}
                data-testid="testimonial-item"
              >
                <Card.Body className="py-5 testimonials__content">
                  <Card.Text as={"div"}>
                    <div className="testimonials__customer">
                      {!!testimonial.avatar && (
                        <Image
                          roundedCircle
                          src={testimonial.avatar}
                          style={{ width: 80, height: 80 }}
                          className="mb-3"
                        />
                      )}
                      {!testimonial.avatar && (
                        <div className="testimonials__customer--char-image mb-3">
                          {testimonial.name?.trim()?.[0]}
                        </div>
                      )}
                      <div className="testimonials__customer--details d-flex flex-column mb-3">
                        <div className="fw-bold">{testimonial.name}</div>
                        <div>
                          {testimonial.companyTitle ||
                            (!!testimonial.reviewLink &&
                              !!testimonial.reviewLinkText && (
                                <Fragment>
                                  Review from{" "}
                                  <a
                                    color="default"
                                    href={testimonial.reviewLink}
                                  >
                                    {testimonial.reviewLinkText}
                                  </a>
                                </Fragment>
                              )) ||
                            fbt("Review from Google")}
                        </div>
                        <div>
                          {Array(testimonial.stars || 5)
                            .fill(1)
                            .map((_value, index) => (
                              <Icon name="star" key={index} />
                            ))}
                        </div>
                      </div>
                    </div>
                    {testimonial.testimonial}
                  </Card.Text>
                </Card.Body>
              </Card>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}
